import { differenceInMonths } from "date-fns";

export const getInterval = (startDate?: Date, endDate?: Date) => {
  if (!startDate && !!endDate) return "month";
  if (!startDate) return "day";
  if (!endDate) return "day";
  const monthDiff = differenceInMonths(endDate, startDate);

  if (monthDiff > 18) {
    return "month";
  }

  if (monthDiff > 3) {
    return "week";
  }

  return "day";
};
